import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectAllWhereaboutsOptions } from '@features/whereabouts/store/whereaboutsOptions.duck';
import { UNKNOWN_OPTION, WhereaboutsOption } from '@features/whereabouts/services/WhereaboutOptions';
import { getIdFromKeyIfDefaultWhereaboutsOverridden } from '@shared/utils/WhereaboutsHelper';

export type WhereaboutsOptionResolver = (statusId: number) => WhereaboutsOption;

export function useWhereaboutsOptionResolver(): WhereaboutsOptionResolver {
  const whereaboutsOptions = useSelector(selectAllWhereaboutsOptions);

  return useCallback((statusId: number) => {
    const id = getIdFromKeyIfDefaultWhereaboutsOverridden(whereaboutsOptions, statusId);
    return whereaboutsOptions.find((o: WhereaboutsOption) => o.id === id) || UNKNOWN_OPTION;
  }, [whereaboutsOptions]);
}
